<template>
  <div class="calendarView">
    <el-form ref="titleInformation" class="titleInformation" :model="titleList" label-width="100px">
      <div class="title">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('currenciesAndCalendar.searchCalendar.calendarCode')">
              <el-input v-model="titleList.calendarCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('currenciesAndCalendar.searchCalendar.calendarDesc')">
              <el-input v-model="titleList.calendarDesc" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('currenciesAndCalendar.searchCalendar.calendarType')">
              <el-input v-model="titleList.calendarTypeDesc" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('currenciesAndCalendar.searchCalendar.currentOpenYear')">
              <el-input v-model="titleList.currentOpenYear" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="calendarTable">
      <div class="viewTitle">
        <el-button type="primary" icon="el-icon-plus" class="creatButton" @click="creatNextYear">{{
          $t('currenciesAndCalendar.calendarView.creatNextYear')
        }}</el-button>
      </div>
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'isAdjustmentPeriod'">
              <p v-if="scope.row[item.prop] == 0">N</p>
              <p v-else-if="scope.row[item.prop] == 1">Y</p>
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/financeCenter/searchCalendar';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    name: 'calendarView',
    mixins: [tableMixins],
    components: {
      SiruiTable,
    },
    computed: {
      titleInformation() {
        return this.$route.query;
      },
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'calendarCode',
            label: this.$t('currenciesAndCalendar.searchCalendar.calendarCode'),
          },
          {
            prop: 'calendarYear',
            label: this.$t('currenciesAndCalendar.calendarView.calendarYear'),
          },
          {
            prop: 'calendarQuarter',
            label: this.$t('currenciesAndCalendar.calendarView.calendarQuarter'),
          },
          {
            prop: 'calendarOrder',
            label: this.$t('currenciesAndCalendar.calendarView.calendarOrder'),
          },
          {
            prop: 'periodName',
            label: this.$t('currenciesAndCalendar.calendarView.periodName'),
          },
          {
            prop: 'detailStartDate',
            label: this.$t('currenciesAndCalendar.calendarView.detailStartDate'),
          },
          {
            prop: 'detailEndDate',
            label: this.$t('currenciesAndCalendar.calendarView.detailEndDate'),
          },
          {
            prop: 'isAdjustmentPeriod',
            label: this.$t('currenciesAndCalendar.calendarView.isAdjustmentPeriod'),
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        tableData: [],
        titleList: {},
        sequenceOrderList: [], //日期类型列表
      };
    },
    mounted() {
      this.titleList = this.titleInformation;
      this.getNationality();
      this.getData();
    },
    methods: {
      //创建下一年日历
      creatNextYear() {
        const { calendarCode, version } = this.titleList;
        const params = { calendarCode, version };
        this.loading.startLoading();
        this.$axios.get(API.CREATE_NEXTYEAR_CALENDAR, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            //  this.tableData = res.data.data.list;
            this.titleList = res.data.data;
            this.sequenceOrderList.forEach((item) => {
              if (this.titleList.calendarType == item.value) {
                this.titleList.calendarTypeDesc = item.label;
              }
            });

            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getData() {
        const { calendarCode } = this.titleList;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { pageNum, pageSize, calendarCode };
        // console.log(params)
        this.load = true;
        this.$axios.get(API.LIST_ACCOUNT_CALEDAR_DETAILS, params).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      //获取日历类型
      async getNationality() {
        let params = {
          dictType: 'calendar_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.sequenceOrderList = selectStatus.data.data;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .calendarView {
    .title[data-v-45f7d399] {
      background-color: white;
      padding: 0 10px;
      padding-left: 0px;
    }
    .calendarTable {
      background-color: white;
      margin-top: 10px;
    }
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .viewTitle {
      height: 30px;
      line-height: 30px;
      padding: 10px;
      //  .creatButton{float: right}
    }
    .sirui-table[data-v-3c6ed471] {
      /* padding-top: 0px; */
      padding: 10px;
      padding-top: 0px;
    }
  }
</style>
